"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntityDescriptionBanner = exports.EntityDescriptionBannerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var responsive_image_1 = require("../elements/responsive-image");
var use_entity_definition_1 = require("../../hooks/use-entity-definition");
var use_full_screen_state_1 = require("../../hooks/use-full-screen-state");
var entity_title_1 = require("./entity-title");
var content_1 = require("../elements/content");
var section_label_1 = require("../elements/section-label");
var image_fill_1 = require("./image-fill");
exports.EntityDescriptionBannerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    color: ", ";\n\n  "], ["\n    display: flex;\n    flex-direction: column;\n    background: ", ";\n    color: ", ";\n\n  "])), theme_1.theme.COLOR('canvas'), theme_1.theme.COLOR('strong')),
  tablet: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex-direction: row;\n  "], ["\n    flex-direction: row;\n  "]))),
  last: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      flex-direction: column !important;\n    "], ["\n      flex-direction: column !important;\n    "])));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-grow: 1;\n    order: 2;\n    padding: ", ";\n  "], ["\n    flex-grow: 1;\n    order: 2;\n    padding: ", ";\n  "])), theme_1.theme.UNIT(3)),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    padding: ", ";\n  "], ["\n    padding: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-weight: 400;\n  "], ["\n    font-weight: 400;\n  "])))
});
var AsideStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex-shrink: 0;\n    width: 100%;\n    order: 1;\n  "], ["\n    flex-shrink: 0;\n    width: 100%;\n    order: 1;\n  "]))),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    width: 25%;\n  "], ["\n    width: 25%;\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    width: 33.33333%;\n  "], ["\n    width: 33.33333%;\n  "]))),
  last: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", "\n\n  "], ["\n    ", "\n\n  "])), function (props) {
    return props.isFullScreen && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      width: 100% !important;\n      order: 1;\n    "], ["\n      width: 100% !important;\n      order: 1;\n    "])));
  })
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n\n    color: ", ";\n    ", ";\n  "], ["\n\n    color: ", ";\n    ", ";\n  "])), theme_1.theme.COLOR('entity-banner-title'), theme_1.theme.FILL('entity-banner-title'))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    color: ", ";\n    margin-top: ", ";\n  "], ["\n    color: ", ";\n    margin-top: ", ";\n  "])), theme_1.theme.COLOR('entity-banner'), theme_1.theme.UNIT(2)),
  tablet: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    padding-right: ", ";\n  "], ["\n    padding-right: ", ";\n  "])), theme_1.theme.UNIT(4))
});
var ImageFillStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: (0, styled_components_1.default)(section_label_1.SectionLabel)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Title: (0, styled_components_1.default)(entity_title_1.EntityTitle)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Aside: styled_components_1.default.div(templateObject_23 || (templateObject_23 = __makeTemplateObject(["", ""], ["", ""])), AsideStyles),
  FullScreenImageContainer: (0, styled_components_1.default)(responsive_image_1.ResponsiveImage)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["", ""], ["", ""])), ImageFillStyles),
  ImageFill: (0, styled_components_1.default)(image_fill_1.ImageFill)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["", ""], ["", ""])), ImageFillStyles),
  Image: styled_components_1.default.img(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles)
};
var EntityDescriptionBanner = function (props) {
  var className = props.className,
    entity = props.entity; // 
  var banner = entity.banner,
    description = entity.description;
  var image = banner && (banner.thumbnail || banner.image || banner.image2x);
  var fullScreenImage = banner && (banner.image2x || banner.image || banner.thumbnail);
  var content = description && description.textTruncated || description.text;
  var isFullScreen = (0, use_full_screen_state_1.useFullScreenState)().isFullScreen;
  var definition = (0, use_entity_definition_1.useEntityDefinition)(entity);
  return react_1.default.createElement(My.Container, {
    isFullScreen: isFullScreen,
    className: className
  }, banner && react_1.default.createElement(My.Aside, {
    isFullScreen: isFullScreen
  }, isFullScreen ? react_1.default.createElement(My.FullScreenImageContainer, {
    fill: true,
    aspectRatio: {
      base: 16 / 9
    },
    image: react_1.default.createElement(My.Image, {
      src: fullScreenImage.url,
      alt: banner.alternateText
    })
  }) : react_1.default.createElement(My.ImageFill, {
    entity: image,
    alt: banner.alternateText
  })), react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Label, null, definition.label, ":"), react_1.default.createElement(My.Title, {
    entity: entity
  }, entity.name), react_1.default.createElement(My.Description, {
    verySmall: true,
    html: content
  })));
};
exports.EntityDescriptionBanner = EntityDescriptionBanner;
exports.EntityDescriptionBanner.defaultProps = exports.EntityDescriptionBannerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26;